import type { ConstValues } from '../helpers.ts';
import type { AppBundleIdOptionPayload, AppInventoryOptionPayload } from './inventoryAndContent.ts';

export const AppInventoryVersion = {
  APP_INVENTORY_EXCLUDED_V1: '0',
  APP_INVENTORY_INCLUDED_V1: '1',
  APP_INVENTORY_ONLY_V2: '2',
} as const;
export type AppInventoryVersionType = ConstValues<typeof AppInventoryVersion>;

export const AppInventoryOption = {
  APP_BUNDLE_ID: 'app_bundle_id',
  APP_INVENTORY: 'app_inventory',
  APP_GROUP: 'appgroup',
  APP_INVENTORY_INTER_DIMENSION_OPERATOR: 'app_inventory_inter_dimension_operator',
} as const;
export type AppInventoryOptionType = ConstValues<typeof AppInventoryOption>;

export type AppInventoryState = {
  [AppInventoryOption.APP_BUNDLE_ID]: AppBundleIdOptionPayload;
  [AppInventoryOption.APP_GROUP]: AppInventoryOptionPayload;
};
